import { render, staticRenderFns } from "./organizationLeadCard.vue?vue&type=template&id=1e4d3762&"
import script from "./organizationLeadCard.vue?vue&type=script&lang=js&"
export * from "./organizationLeadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports